import { combineReducers } from '@reduxjs/toolkit';
import { articleReducer } from './articleReducer';
import { articlesReducer } from './articlesReducer';
import { sitesReducer } from './sitesReducer';
import { siteFormReducer } from './siteFormReducer';
import { clientsReducer } from './clientsReducer';
import { clientFormReducer } from './clientFormReducer';
import { commonInfoReducer } from './commonInfoReducer';
import { goodsReducer } from './goodsReducer';
import { goodsToSiteFormReducer } from './goodsToSiteFormReducer';
import { clientDetailsReducer } from './clientDetailsReducer';
import { orderDetailsReducer } from './orderDetailsReducer';
import { ordersReducer } from './ordersReducer';
import { orderFormReducer } from './orderFormReducer';
import { goodsToOrderFormReducer } from './goodsToOrderFormReducer';
import { receiptFormReducer } from './receiptFormReducer';
import { waybillFormReducer } from './waybillFormReducer';
import { orderGoodsItemsReducer } from './orderGoodsItemsReducer';
import { cancelOrderFormReducer } from './cancelOrderFormReducer';
import { collapsibleOpenStateReducer } from './collapsibleOpenStateReducer';
import { goodsStatusManipulationFormReducer } from './goodsStatusManipulationFormReducer';
import { demandOrderFormReducer } from './demandOrderFormReducer';
import { demandOrdersReducer } from './demandOrdersReducer';
import { returnOrdersReducer } from './returnOrdersReducer';
import { returnOrderFormReducer } from './returnOrderFormReducer';
import { purchaseOrdersReducer } from './purchaseOrdersReducer';
import { purchaseOrderFormReducer } from './purchaseOrderFormReducer';
import { goodsToPurchaseOrderFormReducer } from './goodsToPurchaseOrderReducer';
import { loggedEmployeeReducer } from './loggedEmployeeReducer';
import { labelsReducer } from './labelsReducer';
import { labelsFormReducer } from './labelReducer';
import { closeOrderFormReducer } from './closeOrderFormReducer';
import { siteOwnerFormReducer } from './siteOwnerFormReducer';
import { companyDetailsReducer } from './companyDetailsReducer';
import { acceptOrderFormReducer } from './acceptOrderFormReducer';
import { projectsReducer } from './projectsReducer';
import { projectFormReducer } from './projectFormReducer';

const rootReducer = combineReducers({
    article: articleReducer,
    articles: articlesReducer,
    sites: sitesReducer,
    site: siteFormReducer,
    clientForm: clientFormReducer,
    clients: clientsReducer,
    clientDetails: clientDetailsReducer,
    commonInfo: commonInfoReducer,
    goods: goodsReducer,
    orderGoodsItems: orderGoodsItemsReducer,
    goodsForm: goodsToSiteFormReducer,
    orderDetails: orderDetailsReducer,
    orders: ordersReducer,
    orderForm: orderFormReducer,
    goodsToOrderForm: goodsToOrderFormReducer,
    receiptForm: receiptFormReducer,
    waybillForm: waybillFormReducer,
    cancelOrderForm: cancelOrderFormReducer,
    acceptOrderForm: acceptOrderFormReducer,
    closeOrderForm: closeOrderFormReducer,
    collapsibles: collapsibleOpenStateReducer,
    goodsStatusManipulation: goodsStatusManipulationFormReducer,
    demandOrders: demandOrdersReducer,
    demandOrderForm: demandOrderFormReducer,
    returnOrders: returnOrdersReducer,
    returnOrderForm: returnOrderFormReducer,
    purchaseOrders: purchaseOrdersReducer,
    purchaseOrderForm: purchaseOrderFormReducer,
    goodsToPurchaseOrderForm: goodsToPurchaseOrderFormReducer,
    loggedEmployee: loggedEmployeeReducer,
    labels: labelsReducer,
    label: labelsFormReducer,
    siteOwners: siteOwnerFormReducer,
    companyDetails: companyDetailsReducer,
    projects: projectsReducer,
    projectForm: projectFormReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
